import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import styles from "../../../styles/Navbar.module.css";
import styles from "../../../src/styles/Navbar.module.css";
import DropdownMobileIcon from "../../assets/icons/dropdownmobile.svg";
import { Link } from "react-router-dom";
import { useSidebar } from "../../context/sidebarContext";

export const NavigationBarTestingMode = ({}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { toggleSidebar, setIsOpenUpgradeDialog } = useSidebar();

  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/dashboard");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <nav
      className={
        styles.navbar + " xl:!w-[calc(100%-260px)] xl:!ml-auto !z-[994]"
      }
    >
      <div className={styles.logoContainer}>
        <img
          src="/images/icons/icon_nav_mobile_drawer.svg"
          alt="drawer"
          className="cursor-pointer xl:hidden"
          onClick={toggleSidebar}
        />
        <div className="w-[1px] h-9 bg-[#D1D1D6] mx-4 xl:hidden"></div>
        <img
          src="/images/icons/icon_nav_mobile_xeno.svg"
          alt="xeno"
          className="cursor-pointer xl:!hidden"
        />

        {/* <div className={styles.logo + " max-xl:!hidden"}>
          <div
            className={styles.iconContainer}
            onClick={handleLogoClick}
            style={{ cursor: "pointer" }}
          >
            <img
              src="/images/Xenorize logo_Purple_D.png"
              alt="Platform logo"
              className={styles.logoIcon}
            />
          </div>
        </div> */}
      </div>
    </nav>
  );
};
